import React, { useState } from 'react';
import { ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { AutoCompleteSelect, AutoCompleteInput } from '../../../../components';
import { AddIcon, SearchIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    // flex: '0 0 5.063rem',
    padding: '0 0.625rem',
    // display: 'flex',
    // justifyContent: 'space-between',
    // display: 'flex',
    // alignItems: 'center',
    borderBottom: 'solid 1px #ddd',
    // flexWrap: 'wrap',
  },
  inputBox: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    // flex: '1 0',
    '& > div': {
      marginLeft: '1.25rem',
    },
  },
  search: {
    width: '13.188rem',
    height: '2.563rem',
    borderRadius: '0.5rem',
    border: 'solid 1px #e4e7eb',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 0.313rem 0 0.938rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  searchBtn: {
    width: '1.875rem',
    height: '1.875rem',
    borderRadius: '0.5rem',
    backgroundColor: '#4c93ff',
    color: '#fff',
    fontSize: '1.125rem',
    flex: '0 0 1.875rem',
    // flex: 1,
  },
  addBtn: {
    width: '8.813rem',
    height: '3rem',
    backgroundColor: '#538fff',
    borderRadius: '0.625rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
  },
  addIcon: {
    fontSize: '1rem',
    marginRight: '0.313rem',
  },
}));

// selectList => [] => {} => id, itemList, placeholder, value, onChange
export default function Base({ searchPlace, searchClick, selectList, addTitle, addClick, onChange }) {
  const classes = useStyles();
  // search
  const [searchValue, setSearchValue] = useState('');
  const searchChange = (event) => {
    setSearchValue(event.target.value);
    if (typeof onChange === 'function') {
      onChange(event.target.value);
    }
  };
  const searchBtnClick = () => {
    if (typeof searchClick === 'function') {
      searchClick(searchValue);
    }
  };

  // add
  const addBtnClick = () => {
    if (typeof addClick === 'function') {
      addClick();
    }
  };

  const selectsCtr = () => {
    return (
      Array.isArray(selectList) &&
      selectList.map((item, length) => {
        return item?.allowInput ?? false ? (
          <AutoCompleteInput
            id={`setting_tool_select${length}`}
            key={item.placeholder}
            itemList={item.itemList}
            width="13.188rem"
            height="2.563rem"
            placeholder={item.placeholder}
            value={item.value}
            onChange={item.onChange}
            style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}
          />
        ) : (
          <AutoCompleteSelect
            id={`setting_tool_select${length}`}
            key={item.placeholder}
            itemList={item.itemList}
            width="13.188rem"
            height="2.563rem"
            placeholder={item.placeholder}
            value={item.value}
            onChange={item.onChange}
            style={{ marginTop: '1rem', marginBottom: '1rem' }}
          />
        );
      })
    );
  };

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className={classes.inputBox}>
          <div className={classes.search} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
            <InputBase
              id="setting_tool_input1"
              placeholder={searchPlace}
              value={searchValue}
              onChange={searchChange}
              onKeyDown={(event) => {
                if (event.code === 'Enter' || event.code === 'NumpadEnter') {
                  searchBtnClick();
                }
              }}
            />
            <ButtonBase id="setting_tool_btn1" className={classes.searchBtn} onClick={searchBtnClick}>
              <SearchIcon style={{ fontSize: '1.125rem' }} />
            </ButtonBase>
          </div>
          {selectsCtr()}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column-reverse', justifyContent: 'center' }}>
          {addTitle ? (
            <ButtonBase
              id="setting_tool_add_btn1"
              className={classes.addBtn}
              onClick={addBtnClick}
              style={{ margin: '1rem 1.25rem' }}
            >
              <AddIcon className={classes.addIcon} />
              {addTitle}
            </ButtonBase>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}
